__turbopack_context__.v({
  "glyph": "ThemeToggle-module__UvLW0G__glyph",
  "moon": "ThemeToggle-module__UvLW0G__moon",
  "stage": "ThemeToggle-module__UvLW0G__stage",
  "sun": "ThemeToggle-module__UvLW0G__sun",
  "toggle": "ThemeToggle-module__UvLW0G__toggle",
});
